// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__I7Er6","tooltipContent":"Tag_tooltipContent__GZ12e"};